if (!customElements.get('rental-savings-bar')) {
  class RentalSavingsBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.options = this.querySelectorAll('.rental-savings-bar__option');
      this.progressList = this.querySelector('[data-progress-list]');
      this.progressFill = this.querySelector('[data-savings-fill]');
      this.savingsMin = this.querySelector('[data-savings-min]');
      this.savingsMax = this.querySelector('[data-savings-max]');
      this.variants = JSON.parse(this.querySelector('[data-variants-json]').textContent);
      this.sectionId = this.dataset.section;
      this.durationOptionIndex = parseInt(this.dataset.durationOptionIndex);
      this.durationOptionName = this.dataset.durationOptionName;
      this.hasMultipleOptions = this.dataset.hasMultipleOptions === 'true';

      this.calculateSavings();
      this.bindEvents();
      this.hideDurationFieldset();
      this.updateComparePrice();

      try {
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
          var self = this;
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
            if (event && event.data && event.data.sectionId === self.sectionId) {
              setTimeout(function () { self.updateComparePrice(); }, 0);
            }
          });
        }
      } catch (e) { /* no-op: pub-sub not available */ }
    }

    disconnectedCallback() {
      if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
    }

    hideDurationFieldset() {
      const sectionEl = document.querySelector('#MainProduct-' + this.sectionId)
        || this.closest('.product');
      if (!sectionEl) return;

      const fieldsets = sectionEl.querySelectorAll('variant-radios fieldset, variant-selects .product-form__input--dropdown');
      if (fieldsets.length === 0) return;

      /* Use visibility + height instead of display:none to keep
         Shopify's variant change JS working properly */
      var hideStyle = 'visibility:hidden;position:absolute;height:0;overflow:hidden;pointer-events:none;';

      if (!this.hasMultipleOptions) {
        var variantPicker = sectionEl.querySelector('variant-radios, variant-selects');
        if (variantPicker) {
          variantPicker.setAttribute('style', hideStyle);
        }
      } else {
        fieldsets.forEach(function(fieldset, index) {
          if (index === this.durationOptionIndex) {
            fieldset.setAttribute('style', hideStyle);
          }
        }.bind(this));
      }
    }

    calculateSavings() {
      var durationIdx = this.durationOptionIndex;
      var durationValues = Array.from(this.options).map(function(o) { return o.dataset.durationValue; });

      /* For multi-option products (e.g. Mietverlängerung: Produkt × Mietdauer)
         only consider variants matching the currently selected non-duration
         options, otherwise basePrice/optionPrice would reflect the cheapest
         product across all products instead of the selected one. */
      var selectedOptions = this.hasMultipleOptions ? this.getCurrentSelectedOptions() : [];
      var matchesOtherOptions = function(v) {
        for (var i = 0; i < selectedOptions.length; i++) {
          if (i === durationIdx) continue;
          if (selectedOptions[i] && v.options[i] !== selectedOptions[i]) return false;
        }
        return true;
      };

      var baseVariants = this.variants.filter(function(v) {
        return v.available && v.options[durationIdx] === durationValues[0] && matchesOtherOptions(v);
      });
      var basePrice = baseVariants.length > 0
        ? Math.min.apply(null, baseVariants.map(function(v) { return v.price; }))
        : this.variants[0].price;

      var self = this;
      var baseDays = this.parseDurationDays(durationValues[0]);
      this.options.forEach(function(option, index) {
        var savingLabel = option.querySelector('[data-saving-label]');
        if (!savingLabel) return;

        var durationValue = option.dataset.durationValue;
        var days = self.parseDurationDays(durationValue);
        /* Multiplier from actual durations so non-linear steps (e.g. 1/2/4 weeks) work */
        var multiplier = (baseDays > 0 && days > 0) ? (days / baseDays) : (index + 1);

        var optionPrice;
        if (index === 0) {
          optionPrice = basePrice;
          savingLabel.textContent = 'Basis';
          option.dataset.savingPercent = '0';
          option.dataset.savingAmount = '0';
        } else {
          var matchingVariants = self.variants.filter(function(v) {
            return v.available && v.options[durationIdx] === durationValue && matchesOtherOptions(v);
          });
          optionPrice = matchingVariants.length > 0
            ? Math.min.apply(null, matchingVariants.map(function(v) { return v.price; }))
            : Math.round(basePrice * multiplier);

          var expectedPrice = basePrice * multiplier;
          var saving = expectedPrice - optionPrice;
          var savingPercent = Math.round((saving / expectedPrice) * 100);

          if (savingPercent > 0) {
            savingLabel.textContent = 'Spare ' + savingPercent + '%';
            option.dataset.savingPercent = String(savingPercent);
            option.dataset.savingAmount = String(saving);
          } else {
            savingLabel.textContent = '';
            option.dataset.savingPercent = '0';
            option.dataset.savingAmount = '0';
          }
        }

        option.dataset.optionPrice = String(optionPrice);
        option.dataset.optionDays = String(days);
      });

      this.updateSavingsLabel();
    }

    getCurrentSelectedOptions() {
      var sectionEl = document.querySelector('#MainProduct-' + this.sectionId)
        || this.closest('.product');
      if (!sectionEl) return [];

      var result = [];
      var allFieldsets = sectionEl.querySelectorAll('variant-radios fieldset');
      var allSelects = sectionEl.querySelectorAll('variant-selects select');

      if (allFieldsets.length > 0) {
        allFieldsets.forEach(function(fieldset) {
          var checked = fieldset.querySelector('input[type="radio"]:checked');
          result.push(checked ? checked.value : null);
        });
      } else if (allSelects.length > 0) {
        allSelects.forEach(function(select) {
          result.push(select.value || null);
        });
      }
      return result;
    }

    parseDurationDays(value) {
      if (!value) return 0;
      var dayMatch = value.match(/(\d+)\s*Tag/i);
      if (dayMatch) return parseInt(dayMatch[1]);
      var weekMatch = value.match(/(\d+)\s*Woche/i);
      if (weekMatch) return parseInt(weekMatch[1]) * 7;
      var monthMatch = value.match(/(\d+)\s*Monat/i);
      if (monthMatch) return parseInt(monthMatch[1]) * 30;
      return 0;
    }

    updateSavingsLabel() {
      var label = this.querySelector('[data-savings-label-current]');
      var badge = this.querySelector('[data-daily-price-badge]');
      var activeOption = this.querySelector('.rental-savings-bar__option--active');

      if (!activeOption) return;

      if (label) {
        var savingAmount = parseInt(activeOption.dataset.savingAmount || '0');
        if (savingAmount > 0) {
          var formatted = (savingAmount / 100).toLocaleString('de-DE', {
            style: 'currency',
            currency: 'EUR'
          });
          label.textContent = 'Du sparst ' + formatted;
        } else {
          label.textContent = 'Basispreis';
        }
      }

      if (badge) {
        var price = parseInt(activeOption.dataset.optionPrice || '0');
        var days = parseInt(activeOption.dataset.optionDays || '0');
        if (price > 0 && days > 0) {
          var daily = (price / 100) / days;
          var dailyFormatted = daily.toLocaleString('de-DE', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          });
          badge.textContent = 'nur ' + dailyFormatted + '/Tag';
          badge.style.display = 'inline-block';
        } else {
          badge.style.display = 'none';
        }
      }
    }

    bindEvents() {
      this.options.forEach(option => {
        option.addEventListener('click', () => {
          this.selectOption(option);
          this.setDurationInVariantPicker(option.dataset.durationValue);
        });
      });

      document.addEventListener('change', (event) => {
        const target = event.target;
        if (target.closest('variant-radios') || target.closest('variant-selects')) {
          setTimeout(() => this.syncFromVariantPicker(), 50);
        }
      });
    }

    selectOption(option) {
      this.options.forEach(o => o.classList.remove('rental-savings-bar__option--active'));
      option.classList.add('rental-savings-bar__option--active');
      if (this.progressList) {
        const idx = Array.from(this.options).indexOf(option);
        this.progressList.setAttribute('data-active-step', String(idx));
      }
      this.updateSavingsLabel();
      this.updateComparePrice();
    }

    updateComparePrice() {
      var priceEl = document.getElementById('price-' + this.sectionId);
      if (!priceEl) return;

      var activeOption = this.querySelector('.rental-savings-bar__option--active');
      if (!activeOption || !this.options.length) return;

      var index = Array.from(this.options).indexOf(activeOption);

      if (index <= 0) {
        priceEl.classList.remove('price--on-sale');
        priceEl.classList.remove('rental-compare-active');
        this.toggleSaleBadges(priceEl, false);
        return;
      }

      var baseOption = this.options[0];
      var basePriceCents = parseInt(baseOption.dataset.optionPrice || '0');
      var currentPriceCents = parseInt(activeOption.dataset.optionPrice || '0');
      var baseDays = parseInt(baseOption.dataset.optionDays || '0');
      var currentDays = parseInt(activeOption.dataset.optionDays || '0');
      /* Multiplier from actual durations so non-linear steps (e.g. 1/2/4 weeks) work */
      var multiplier = (baseDays > 0 && currentDays > 0) ? (currentDays / baseDays) : (index + 1);
      var comparePriceCents = Math.round(basePriceCents * multiplier);

      if (!basePriceCents || comparePriceCents <= currentPriceCents) {
        priceEl.classList.remove('price--on-sale');
        priceEl.classList.remove('rental-compare-active');
        this.toggleSaleBadges(priceEl, false);
        return;
      }

      var fmt = function (cents) {
        return (cents / 100).toLocaleString('de-DE', {
          style: 'currency',
          currency: 'EUR'
        });
      };

      var saleContainer = priceEl.querySelector('.price__sale');
      if (saleContainer) {
        var regularItem = saleContainer.querySelector('.price-item--regular');
        var saleItem = saleContainer.querySelector('.price-item--sale');
        if (regularItem) regularItem.textContent = fmt(comparePriceCents);
        if (saleItem) saleItem.textContent = fmt(currentPriceCents);
      }

      priceEl.classList.add('price--on-sale');
      priceEl.classList.add('rental-compare-active');
      this.toggleSaleBadges(priceEl, true);
    }

    toggleSaleBadges(priceEl, hide) {
      var sectionEl = document.querySelector('#MainProduct-' + this.sectionId)
        || this.closest('.product')
        || document;
      var selectors = [
        '.price__badge-sale',
        '.badge--sale',
        '.product__badge',
        '.price__badge',
        '.badge.color-accent-2'
      ];
      var nodes = [];
      selectors.forEach(function (sel) {
        sectionEl.querySelectorAll(sel).forEach(function (n) { nodes.push(n); });
      });
      nodes.forEach(function (el) {
        if (hide) {
          el.setAttribute('data-rental-hidden', '1');
          el.style.display = 'none';
        } else if (el.getAttribute('data-rental-hidden') === '1') {
          el.removeAttribute('data-rental-hidden');
          el.style.display = '';
        }
      });
    }

    setDurationInVariantPicker(durationValue) {
      var sectionEl = document.querySelector('#MainProduct-' + this.sectionId)
        || this.closest('.product');
      if (!sectionEl) return;

      var variantRadios = sectionEl.querySelector('variant-radios');
      var variantSelects = sectionEl.querySelector('variant-selects');

      /* Trigger change on the hidden variant picker */
      if (variantRadios) {
        var inputs = variantRadios.querySelectorAll('input[type="radio"]');
        inputs.forEach(function(input) {
          if (input.value === durationValue && input.name === 'option' + (this.durationOptionIndex + 1)) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }.bind(this));
      } else if (variantSelects) {
        var selects = variantSelects.querySelectorAll('select');
        var select = selects[this.durationOptionIndex];
        if (select) {
          select.value = durationValue;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      /* Directly find and set the correct variant ID on the form input
         as a fallback in case the variant picker events don't propagate */
      this.updateFormVariantId(durationValue, sectionEl);
    }

    updateFormVariantId(durationValue, sectionEl) {
      /* Build current options array based on all option selectors */
      var currentOptions = [];
      var allFieldsets = sectionEl.querySelectorAll('variant-radios fieldset');
      var allSelects = sectionEl.querySelectorAll('variant-selects select');

      if (allFieldsets.length > 0) {
        allFieldsets.forEach(function(fieldset, idx) {
          if (idx === this.durationOptionIndex) {
            currentOptions.push(durationValue);
          } else {
            var checked = fieldset.querySelector('input[type="radio"]:checked');
            currentOptions.push(checked ? checked.value : '');
          }
        }.bind(this));
      } else if (allSelects.length > 0) {
        allSelects.forEach(function(select, idx) {
          if (idx === this.durationOptionIndex) {
            currentOptions.push(durationValue);
          } else {
            currentOptions.push(select.value);
          }
        }.bind(this));
      }

      /* Find matching variant */
      var matchedVariant = this.variants.find(function(v) {
        return v.options.every(function(opt, idx) {
          return !currentOptions[idx] || opt === currentOptions[idx];
        });
      });

      if (!matchedVariant) return;

      /* Update all hidden variant ID inputs in forms */
      var formInputs = sectionEl.querySelectorAll('input[name="id"].product-variant-id, input[name="id"][type="hidden"]');
      formInputs.forEach(function(input) {
        input.value = matchedVariant.id;
        input.removeAttribute('disabled');
      });

      /* Update URL */
      var url = new URL(window.location.href);
      url.searchParams.set('variant', matchedVariant.id);
      window.history.replaceState({}, '', url.toString());

      /* Update price display */
      var priceEl = sectionEl.querySelector('.price-item--regular');
      if (priceEl) {
        var formattedPrice = (matchedVariant.price / 100).toLocaleString('de-DE', {
          style: 'currency',
          currency: 'EUR'
        });
        priceEl.textContent = formattedPrice;
      }
    }

    syncFromVariantPicker() {
      const sectionEl = document.querySelector('#MainProduct-' + this.sectionId)
        || this.closest('.product');
      if (!sectionEl) return;

      const variantRadios = sectionEl.querySelector('variant-radios');
      const variantSelects = sectionEl.querySelector('variant-selects');

      let currentDurationValue = null;

      if (variantRadios) {
        const checkedInput = variantRadios.querySelector(
          'input[name="option' + (this.durationOptionIndex + 1) + '"]:checked'
        );
        if (checkedInput) currentDurationValue = checkedInput.value;
      } else if (variantSelects) {
        const selects = variantSelects.querySelectorAll('select');
        const select = selects[this.durationOptionIndex];
        if (select) currentDurationValue = select.value;
      }

      /* Recalculate so basePrice/option prices reflect the freshly selected
         non-duration option (e.g. selected product on the Mietverlängerung page) */
      if (this.hasMultipleOptions) this.calculateSavings();

      if (currentDurationValue) {
        const matchingOption = this.querySelector(
          '[data-duration-value="' + CSS.escape(currentDurationValue) + '"]'
        );
        if (matchingOption) {
          if (!matchingOption.classList.contains('rental-savings-bar__option--active')) {
            this.selectOption(matchingOption);
          } else {
            this.updateSavingsLabel();
            this.updateComparePrice();
          }
        }
      }
    }
  }

  customElements.define('rental-savings-bar', RentalSavingsBar);
}
